import { Mail } from "lucide-react";
import { KIND_LABELS } from "@/lib/emailKinds";
import { fmtDateTime } from "@/lib/format";

const STATUS_STYLE = {
  sent: "text-emerald-400",
  failed: "text-red-400",
  retrying: "text-[#B45309]",
  sending: "text-[#B45309]",
  skipped: "text-[#78716C]",
};

const statusText = (e) => {
  const parts = [e.status];
  if (e.status === "skipped") parts.push("test address");
  if (e.status === "retrying") parts.push(`attempt ${e.attempts || 1}/3`);
  if (e.gave_up) parts.push("gave up after 3");
  if (e.status === "sent" && e.attempts > 1) parts.push(`on retry ${e.attempts}`);
  return parts.join(" · ");
};

const errorText = (err) => (String(err).includes("429") ? "Provider busy (429) — will retry" : err);

export const EmailLogTable = ({ emails, loading }) => (
  <div className="tacc-card overflow-x-auto" data-testid="admin-emails-table">
    <table className="w-full text-sm min-w-[760px]">
      <thead>
        <tr className="text-left font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] border-b border-[#E7DFD5]">
          <th className="p-4">When</th><th className="p-4">Type</th><th className="p-4">To</th><th className="p-4">Subject</th><th className="p-4">Status</th>
        </tr>
      </thead>
      <tbody>
        {emails.map((e) => (
          <tr key={e.id} className="border-b border-[#E7DFD5] hover:bg-black/5" data-testid={`email-row-${e.id}`}>
            <td className="p-4 text-[#78716C] whitespace-nowrap">{fmtDateTime(e.at)}</td>
            <td className="p-4 whitespace-nowrap">{KIND_LABELS[e.kind] || e.kind}</td>
            <td className="p-4 text-[#44403C] text-xs">{e.to || "—"}</td>
            <td className="p-4 text-[#78716C] text-xs max-w-[320px] truncate" title={e.subject}>{e.subject}</td>
            <td className="p-4">
              <span className={`font-mono text-[10px] tracking-[0.2em] uppercase ${STATUS_STYLE[e.status] || ""}`} title={e.error || ""} data-testid={`email-status-${e.id}`}>
                {statusText(e)}
              </span>
              {e.error && <div className="text-[10px] text-red-400/80 mt-1 max-w-[240px] truncate" title={e.error}>{errorText(e.error)}</div>}
            </td>
          </tr>
        ))}
        {!loading && emails.length === 0 && (
          <tr><td colSpan={5} className="p-10 text-center text-[#78716C]"><Mail size={18} className="inline mr-2 text-[#B45309]" />No emails logged yet. Every confirm, receipt, welcome, reminder and digest lands here.</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
